import { useState } from "react";
import InputField from "components/fields/InputField";

import { API_URL } from "config/api";

export default function ForgotPasswordForm({ onSwitchToSignIn }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.detail || "Something went wrong");
      }
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
        Forgot Password
      </h4>
      <p className="mb-9 ml-1 text-base text-gray-600">
        Enter your email address and we'll send you a reset link.
      </p>

      {success ? (
        <div className="rounded-xl bg-green-50 p-4 dark:bg-navy-800">
          <p className="text-sm font-medium text-green-700 dark:text-green-400">
            Check your inbox! If that email is registered, a reset link is on its way.
          </p>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <InputField
            variant="auth"
            extra="mb-3"
            label="Email*"
            placeholder="your@email.com"
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {error && (
            <p className="mb-3 text-sm font-medium text-red-500">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>
      )}

      <div className="mt-4">
        <button
          onClick={onSwitchToSignIn}
          className="cursor-pointer border-none bg-transparent p-0 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
        >
          &larr; Back to Sign In
        </button>
      </div>
    </>
  );
}
